export const PLUGIN_KEY = 'aks-insert-image';

export const MAX_COUNT = 5;

/**
 * Widest an image may be and still fit the email's content column.
 * The column is 600px, minus the template's 8px wrapper padding and its
 * 10px/25px content padding: 600 - (8 * 2) - (25 * 2) = 534.
 */
export const MAX_IMAGE_WIDTH = 534;

export enum AksInsertImageButton {
  InsertImage = 'aks-insert-image',
  ReselectImage = 'aks-reselect-image',
  EditImage = 'aks-edit-image',
  RemoveImage = 'aks-remove-image',
}
